import React from 'react'
import { Wrapper, Card, Btn } from "../_components"
import Table from '../_components/Table'
import Theme from '../Theme'
import Axios from 'axios'

export default function DisplayRecord() {
    const cropsColumns = React.useMemo(
    () => [
        {
            Header: "#",
            accessor: "idx",
            sortable: false
        },
        {
            Header: "Crop",
            accessor: "crop",
            sortable: false,
            filterable: false,
        },
        {
            Header: "Season",
            accessor: "season"
        },
        {
            Header: "Year",
            accessor: "year"
        },
        {
            Header: "Crop Acreage(Acres)",
            accessor: "acreage"
        },
        {
            Header: "Expected Yield(Kg)",
            accessor: "expected_yield"
        },
        {
            Header: "Actual Yield(Kg)",
            accessor: "actual_yield"
        },
        {
            Header: "Total Cost( UGX )",
            accessor: "total_cost"
        } ]
    )
    const [ record, setRecord ] = React.useState( null )
    const [ loading, setLoading ] = React.useState( true )
    const [ crops, setCrop ] = React.useState( [] )
    const [ loadingCrop, setLoadingCrop ] = React.useState( true )
    const [ productionForm, setProductionForm ] = React.useState( false )

    React.useEffect( () => {
        if( loading ) {
            fetchFarmer()
        }
    },[ loading ])

    const fetchCropInformation = async id => {

        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/getCropInformation/${id}` )
           if( response.data ) {
            const results = response.data.record.map( ( record, index ) => {
                return {
                    idx: index + 1 ,
                    cropId: id,
                    crop: record?.cropname,
                    season: record?.season,
                    year: record?.year,
                    acreage: record?.crop_acreage,
                    expected_yield: record?.expected_yield,
                    actual_yield: record?.actual_yield,
                    total_cost: record?.amount
                }
            } )
            //update the state
            setCrop( results.length > 0 ? results : [] )
            setLoadingCrop( false )
           }
        } catch (error) {
            setLoadingCrop( false ) 
        }
    }

    const fetchFarmer = async () => {
        try {
           const response =  await Axios.get( `https://mis.nec.go.ug/api/auth/farmer/${localStorage.getItem( "farmerId" )}`)
           if( response.data ) {
            await fetchCropInformation( response.data.records[ 0 ]?.view_id )
            setRecord( response.data.records[ 0 ] )
            setLoading( false )
           }
        } catch (error) {
            alert( "Failed to Fetch Farmer." )
            setLoading( false )
        }
    }

    return (
    <Wrapper>
        {loading ? <div className="flex items-center justify-center">
            {`Loading Farmer Details...`}
        </div> : (
            <>
            <div className="flex flex-col">
                <h2 className="text-3xl px-2">
                    {`Farmer Details - ${localStorage.getItem( "scheme" )} - ${record?.first_name} ${record?.last_name}`}
                </h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-2 items-center my-5">
                    <Card title="Personal Details" icon={Theme.UserIcon}>
                        <ItemDetail label="Full Name" val={`${record?.first_name} ${record?.last_name}`}/>
                        <ItemDetail label="Gender" val={record?.gender}/>
                        <ItemDetail label="Year of Birth" val={record?.birthyear}/>
                        <ItemDetail label="Age" val={record?.age}/>
                        <ItemDetail label="Phone Number" val={record?.primary_contact}/>
                        <ItemDetail label="Alternative Phone Number" val={record?.secondary_contact}/>
                        <ItemDetail label="National ID Number" val={record?.nin}/>
                        <ItemDetail label="Farmer Registration No." val={record?.reg_number}/>
                        <ItemDetail label="Are you a Youth?" val={record?.is_youth}/>
                    </Card>
    
                    <Card title="Farm Details" icon={Theme.TreeIcon}>
                        <ItemDetail label="Block Number" val={record?.block_id}/>
                        <ItemDetail label="Village" val={record?.farm_village}/>
                        <ItemDetail label="Parish" val={record?.farm_parish}/>
                        <ItemDetail label="Subcounty" val={record?.farm_subcounty}/>
                        <ItemDetail label="District" val={record?.district}/>
                        {/* <ItemDetail label="Farm Size" val={record?.farm}/> */}
                        <ItemDetail label="Institution" val={record?.insitution}/>
                        <ItemDetail label="FFSG Number" val={record?.name}/>
                    </Card>
                </div>
            </div>
            <div className="flex flex-col w-full">
                <div className="bg-white my-3 py-2 flex items-center justify-between px-5">
                    <h5 className="text-xl text-center">
                        {`Farmer Production Data`}
                    </h5>
                    <Btn 
                     handlePress={async() => {
                        await localStorage.setItem( "name", "production" )
                        return window.location.reload()
                     } } 
                     label="Add Farmer Production Data" 
                     color={`#8A3FFC`}  
                    />
                </div>
                <Card title="Crops Grown" icon={Theme.CropIcon}>
                        <Table
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="Crops Grown"
                            columns={cropsColumns}
                            data={crops}
                            hidePagination={true}
                            hideDownload={true}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                        />
                    </Card>
                <Card title="Crops Planted Acreage" icon={Theme.CropIcon}>
                    {/* <div>Pie Chart</div> */}
                </Card>
            </div>
            </>
        )}
        
    </Wrapper>
  )
}

const ItemDetail = ( { label, val } ) => {
    return (
        <div className="flex items-center my-2">
            <div className="md:text-sm lg:text-sm font-bold text-black text-xs">
                {`${label}:`}
            </div>
            <div className="px-5 md:text-sm lg:text-sm font-normal text-xs text-gray-500">
                {val}
            </div>
        </div>
    )
}
